import { HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment.dev';

export const BASE_URL = environment.apiUrl;

export const HEADERS_API = new HttpHeaders({
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Headers': 'X-Requested-With',
  'Access-Control-Allow-Methods': 'POST,GET,PUT,OPTIONS',
  'Content-Type': 'application/json; charset=utf-8',
});
